import { RestrictionResult } from '../commons';

export interface RestrictionWarnInputData {
  restrictionInfos: RestrictionResult[0];
  licensePlate?: string;
}

export interface RestrictionWarnContact {
  type: 'contact';
  redirectUri: string;
}

export interface RestrictionWarnCancel {
  type: 'cancel';
}

export type RestrictionWarnOutputData =
  | RestrictionWarnContact
  | RestrictionWarnCancel;
